import { render, staticRenderFns } from "./AboutHelmetRatings.vue?vue&type=template&id=0cfc4964"
import script from "./AboutHelmetRatings.vue?vue&type=script&lang=js"
export * from "./AboutHelmetRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports